<template>
<div class="container">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <form>
        <div class="card">
          <div class="card-header">
            <i class="fa fa-pencil"></i><strong>Webhook</strong><strong></strong>
          </div>
          <div class="card-block">
            <div class="form-group" :class="{'input': true, 'has-danger': errors.has('nome') }">
              <label class="col-form-label">Nome</label>
              <input type="text" name="nome" v-validate="'required'" v-model="webhook.name" class="form-control">

              <span v-show="errors.has('nome')" class="form-control-feedback">{{ errors.first('nome') }}</span>
            </div>

            <label class="col-form-label">Url</label>
            <div class="row">
              <div class="form-group col-md-3" :class="{'select': true, 'has-danger': errors.has('method') }">
                <select class="form-control" name="method" v-validate="'required'" v-model="webhook.method">
                  <option value="post" selected>POST</option>
                </select>
              </div>
              <div class="form-group col-md-9" :class="{'input': true, 'has-danger': errors.has('url') }">
                <input type="text" class="form-control" name="url" v-validate="'required|url'" v-model="webhook.url" placeholder="Preencha com a url">
                <span v-show="errors.has('url')" class="form-control-feedback">{{ errors.first('url') }}</span>
              </div>
            </div>

            <br/>
            <h6>Headers</h6>
            <hr />
            <div class="form-group">
              <label for="inputUrl" class="col-form-label">Parametros</label>
              <div v-for="(item, index) in webhook.headers" :key="index">
                <div class="input-group">
                  <input type="text" class="form-control col-md-3" placeholder="Chave" v-model="item.key">
                  <span class="input-group-addon">=</span>
                  <input type="text" class="form-control col-md-3" placeholder="Valor" v-model="item.value">
                  <button type="button" v-on:click="removeHeader(item)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                  <button type="button" v-on:click="newHeader()" :disabled="index !== (webhook.headers.length - 1)" class="btn btn-sm btn-default"><i class="fa fa-plus"></i></button>
                </div>
              </div>
            </div>

            <hr />
            <div class="form-group" :class="{'input': true, 'has-danger': errors.has('url de retorno') }">
              <label class="col-form-label">Url de retorno</label>
              <input type="text" class="form-control" name="url de retorno" v-validate="'required|url'" placeholder="Url de retorno" v-model="webhook.returnUrl">
              <span v-show="errors.has('url de retorno')" class="form-control-feedback">{{ errors.first('url de retorno') }}</span>
            </div>
          </div>
          <div class="card-footer">
            <div class="pull-right">
              <router-link :to="'/rocket/webhooks'" class="btn btn-sm">
                <i class="fa fa-chevron-left"></i> Cancelar
              </router-link>
              <button type="submit" @click.prevent="saveWebhook" class="btn btn-sm btn-secondary"><i class="fa fa-save"></i> Salvar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'

export default {
  name: 'webhook',
  components: {
    vSelect
  },
  data() {
    return {
      webhook: {
        id: '',
        name: '',
        url: '',
        method: 'post',
        returnUrl: '',
        headers: [{
          key: '',
          value: ''
        }]
      }
    }
  },
  created() {
    if (this.$route.params.id !== undefined) {
      axios.get(process.env.ROCKET_API_URL + 'webhooks/' + this.$route.params.id).then(response => {
        this.webhook = response.data
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao carregar o webhook.')
      })
    }
  },
  watch: {
    'webhook.headers': function(newValue, oldValue) {
      if (this.webhook.headers.length === 0) {
        this.newHeader()
      }
    }
  },
  methods: {
    newHeader: function () {
      this.webhook.headers.push({
        '': ''
      })
    },
    removeHeader: function (header) {
      this.webhook.headers = this.webhook.headers.filter(function (obj) {
        return obj.key !== header.key
      })
    },
    saveWebhook() {
      this.$validator.validateAll()

      if (!this.errors.any()) {
        var body = JSON.parse(JSON.stringify(this.webhook)) // Me desculpa, mas precisei fazer isso devido as referencias
        body.headers = body.headers.filter(h => h.key !== undefined && h.key !== '')

        if (this.$route.params.id !== undefined) {
          axios.put(process.env.ROCKET_API_URL + 'webhooks/' + this.$route.params.id, body)
          .then(response => {
            this.showSuccess('Webhook alterado com sucesso')
            this.$router.push('/rocket/webhooks')
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao salvar o webhook.')
          })
        } else {
          axios.post(process.env.ROCKET_API_URL + 'webhooks', body)
          .then(response => {
            this.showSuccess('Webhook criado com sucesso')
            this.$router.push('/rocket/webhooks')
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao salvar o webhook.')
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?b06e2fcc